import React, { forwardRef } from 'react';
import { Button } from '../Button';
import { st, classes } from './SelectorButton.st.css';
import { SelectorButtonProps } from './SelectorButton.types';
import { SIZES, SKINS } from './SelectorButton.constants';

const SelectorButton = forwardRef(
  (
    {
      dataHook,
      onClick,
      children,
      ellipsis = false,
      showTooltip,
      tooltipProps,
      size = SIZES.MEDIUM,
      skin = SKINS.DARK,
      suffixIcon,
      disabled = false,
      fullWidth = false,
    }: SelectorButtonProps,
    ref: React.LegacyRef<Button>,
  ) => {
    return (
      <Button
        ref={ref}
        as="button"
        dataHook={dataHook}
        className={st(classes.root, { size, skin, disabled })}
        onClick={onClick}
        suffixIcon={suffixIcon}
        ellipsis={ellipsis}
        showTooltip={showTooltip}
        tooltipProps={tooltipProps}
        disabled={disabled}
        fullWidth={fullWidth}
      >
        {children}
      </Button>
    );
  },
);

SelectorButton.displayName = 'SelectorButton';

export { SelectorButton };
